import request from '../../utils/request'
import config from '../../../config/config'
// const baseURL = 'http://localhost:3013'
const baseURL = config.baseUrl;

// 信息列表
export function preAbortOrder (data) {
  return request({
    url: baseURL + 'shanSong/preAbortOrder',
    method: 'post',
    data: data
  })
}
// 信息列表
export function abortOrder (data) {
  return request({
    url: baseURL + 'shanSong/abortOrder',
    method: 'post',
    data: data
  })
}


// WEBPACK FOOTER //
// ./src/api/shansong/shansong.js